export {PdfViewerNg2Module} from './pdf-viewer-ng2.module';
export {PdfViewerNg2Component} from './pdf-viewer-ng2.component';
